module.exports = __webpack_public_path__ + "img/star.b4cbd6df.svg";